import gql from "graphql-tag";

export const GET_THREAD_MESSAGE_COUNT = gql`
	query GetThreadMessageCount($id: ID!, $nodeLabel: SupportedMessageNodes!) {
		GetThreadMessageCount(id: $id, nodeLabel: $nodeLabel)
	}
`;

export const GET_MESSAGES = gql`
	query GetMessages($id: ID!, $nodeLabel: SupportedMessageNodes!) {
		GetMessages(id: $id, nodeLabel: $nodeLabel) {
			createdOn
			content
			sentBy {
				firstName
				lastName
				id
				isDeleted
				organization {
					name
				}
			}
		}
	}
`;

export const SAVE_MESSAGE = gql`
	mutation SaveMessage($input: CreateThreadMessageInput) {
		CreateThreadMessage(input: $input) {
			createdOn
			case {
				id
			}
			sentBy {
				firstName
				lastName
			}
		}
	}
`;

export const THREAD_SUBSCRIPTION = gql`
	subscription OnMessageUpdated {
		threadUpdated
	}
`;

export const DELETE_MESSAGE = gql`
	mutation DeleteThreadMessage($input: DeleteThreadMessageInput) {
		DeleteThreadMessage(input: $input)
	}
`;

export const GET_USERS_TO_MENTION_ON_CASE_MESSAGE = gql`
	query GetUsersToMentionOnCaseMessage($id: ID!) {
		GetUsersToMentionOnCaseMessage(id: $id) {
			email
			firstName
			lastName
		}
	}
`;
